import { render, staticRenderFns } from "./NewFormBuilder.vue?vue&type=template&id=1459c1a7&scoped=true"
import script from "./NewFormBuilder.vue?vue&type=script&lang=js"
export * from "./NewFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./NewFormBuilder.vue?vue&type=style&index=0&id=1459c1a7&prod&lang=scss&scoped=true"
import style1 from "./NewFormBuilder.vue?vue&type=style&index=1&id=1459c1a7&prod&lang=scss&scoped=true"
import style2 from "./NewFormBuilder.vue?vue&type=style&index=2&id=1459c1a7&prod&scoped=true&lang=css"
import style3 from "./NewFormBuilder.vue?vue&type=style&index=3&id=1459c1a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459c1a7",
  null
  
)

export default component.exports